export default __webpack_public_path__ + "static/media/FC-Iconic-Bold.cc627412.ttf";